import e from "./atoms-v272.js";
function n(t) {
  return new e(t).getCountries();
}
export {
  n as default
};
